import TransportForm from "../../../../components/forms/transportForm/index";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Form from "../../../../components/forms/index";
import url from "../../../../config/axios";
import { FailedNotify, SuccessNotify } from "../../../../constants/tostify";
import { useSelector } from "react-redux";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
const UpdateTransport = () => {
  const [displayimg, setDisplayimg] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const { id } = useParams();
  const [selectshop, setSelectshop] = useState({
    shopCategory: "",
  });

  const Shopdatas = (e) => {
    setSelectshop((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = selectshop?.shopCategory[1];
  const categoryid = selectshop?.shopCategory[0];

  localStorage.setItem("mycategory", categoryName);

  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setCreateShop((createShop) => ({
        ...createShop,
        image: abc,
      }));

      setDisplayimg(abc);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });
  const [createShop, setCreateShop] = useState({
    userid: name?._id,
    shopname: "",
    shopaddress: "",
    shoplicense: "",
    contact: "",
    marketPlace: "",
    image: [""],
    shopCategory: categoryid,
    businessType: "transportShop",
    description: "",
    status: true,
  });

  useEffect(() => {
    url
      .get(`shop/id?id=${id}`)
      .then(async (response) => {
        setCreateShop(response?.data?.data?.Shop);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);
  const UpdateShop = (e) => {
    e.preventDefault();

    let submitData = { ...createShop };
    if (submitData.shopCategory && submitData.shopCategory.includes(".")) {
      submitData.shopCategory = submitData.shopCategory.split(".")[0];
    }

    url
      .put(`shop/id?id=${id}`, submitData)
      .then(async (response) => {
        if (response?.data?.success) {
          setTimeout(() => {
            SuccessNotify("Form Update Successfully");
            navigate("/transport-profile/" + id);
          }, 1000);
        }
      })
      .catch((error) => {
        FailedNotify("Failed to Update");
      });
  };
  return (
    <div>
      <TransportForm
        title="Fill to Update Transport Profile"
        butn="Update"
        back="/transport-profile/"
        navigateTo="/transport-profile/"
        UpdateShop={UpdateShop}
        createShop={createShop}
        setCreateShop={setCreateShop}
        id={id}
        inputtitle="Shop Name"
        link="/update-transport/"
        getInputProps={getInputProps}
        getRootProps={getRootProps}
        displayimg={displayimg}
        setDisplayimg={setDisplayimg}
        Shopdatas={Shopdatas}
        isUploading={isUploading}
        uploadProgress={uploadProgress}
      />
    </div>
  );
};
export default UpdateTransport;
